module.exports = __webpack_public_path__ + "img/6-2.2d36d585.png";